<ng-select
	[items]="items"
	[bindLabel]="bindLabel"
	[bindValue]="bindValue"
	[searchable]="searchable"
	[placeholder]="placeholder"
	[clearable]="clearable"
	[loading]="items === undefined"
	[formControl]="formControl"
	(change)="selectedItem($event)"
	(change)="onSelect($event)"
	(focus)="onFocus()"
	[readonly]="readonly"
	class="ng-select-component"
	[class.is-invalid]="formControl?.invalid && formControl?.touched"
	[multiple]="multiple"
	(clear)="onClear($event)"
	[hidden]="hidden"
>
</ng-select>
@if (formControl?.invalid && formControl?.touched) {
	@if (formControl?.errors?.["required"]) {
		<div class="invalid-feedback d-block">Ce champ est obligatoire.</div>
	} @else {
		<div class="invalid-feedback d-block">Ce champ est invalide.</div>
	}
}
